export function getRequestUrl(info: RequestInfo | URL): string {
	if (typeof info === 'string') return info;
	if (info instanceof URL) return info.toString();
	return info.url;
}
